export default __webpack_public_path__ + "src/assets/stepper3.webp";